import React from 'react'
import Banner from '../../components/homepage-components/banner'
import CreateMusic from '../../components/homepage-components/create-music'
import ExploreSmartFormats from '../../components/homepage-components/explore-smart-formats'
import Design from '../../components/homepage-components/design'
import UploadAudio from '../../components/homepage-components/upload-audio'
import Artists from '../../components/homepage-components/artists'

const Homepage = () => {
    return (
        <div>
            <Banner />
            <CreateMusic />
            <ExploreSmartFormats />
            <Design />
            <UploadAudio />
            <Artists />
        </div>
    )
}

export default Homepage
